var map = {
	"./033-bm.webp": 1225,
	"./033-cn.webp": 1226,
	"./033.webp": 1227,
	"./13-bm.webp": 1228,
	"./13-cn.webp": 1229,
	"./13.webp": 1230,
	"./3-bm.webp": 1231,
	"./3-cn.webp": 1232,
	"./3.webp": 1233,
	"./angpao-bg-mobile.jpg": 1234,
	"./angpao-bg.jpg": 1235,
	"./angpao-bm.webp": 1236,
	"./angpao-cn.webp": 1237,
	"./angpao.webp": 1238,
	"./button.png": 1239,
	"./close-eye.png": 1240,
	"./coin-1.png": 1241,
	"./coin.png": 1242,
	"./ketupak-open.png": 1243,
	"./ketupak.png": 1244,
	"./ketupak_ribbon.png": 1245,
	"./rain-1.png": 1246,
	"./rain-2.png": 1247,
	"./rain-3.png": 1248,
	"./raya-bg-mobile.png": 1249,
	"./raya-bg.png": 1250,
	"./shine.png": 1251,
	"./star-1.png": 1252,
	"./star-2.png": 1253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;